



































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { Decks } from "../../store/modules/desk/types";

import DoKoCard from "../card/DoKoCard.vue";
@Component({ components: { DoKoCard } })
export default class DoKoDeck extends Vue {
  // ('♣', 'black'), ('♠', 'black'), ('♥', '#d6002b'), ('♦', '#d6002b')
  // ('A', 'A'), ('10', '10'), ('9', '9'), ('K','K'), ('D','Q'), ('B','J')
  readonly delta = 40;

  @Prop({
    type: String,
    required: true,
  })
  private placeName!: "bottom" | "left" | "top" | "right";

  @Getter(deskApi.getters.getDecks, { namespace: deskApi.namespace })
  decks!: Decks;

  @Getter(deskApi.getters.isMyTurn, { namespace: deskApi.namespace })
  isMyTurn!: boolean;

  @Getter(deskApi.getters.getLoadingState, { namespace: deskApi.namespace })
  loading!: boolean;

  @Getter(deskApi.getters.getPlayedCards, { namespace: deskApi.namespace })
  playedCards!: string[];

  @Getter(deskApi.getters.getAllowedCards, { namespace: deskApi.namespace })
  allowedCards!: string[];

  get deckInfo() {
    return this.decks[this.placeName];
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  private hoverable!: boolean;

  get cards() {
    return this.deckInfo.cards;
  }

  @Prop({
    type: Number,
    default: 1,
  })
  private scale!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get transformText() {
    return `translate(${this.x} ${this.y}) scale(${this.scale})`;
  }

  get cardCount() {
    const cards = this.cards;
    if (typeof cards === "number") {
      return cards;
    } else {
      return cards.length;
    }
  }

  get values() {
    const cards = this.cards;
    if (typeof cards === "number") {
      return Array.from(new Array(cards)).map(_ => ({
        hoverable: false,
        name: "back",
        enabled: true,
      }));
    } else {
      return cards
        .filter(c => !this.playedCards.includes(c))
        .map(c => {
          const enabled = this.allowedCards.includes(c);
          const hoverable = this.isMyTurn && enabled;
          return { hoverable, name: c, enabled };
        });
    }
  }

  get offset() {
    return 0;
    /*
    return (
      (this.playedCards.length % 2) * -(this.delta / 4) +
      this.playedCards.length * (this.delta / 2)
    ); */
  }

  get back() {
    return typeof this.cards === "number";
  }

  @Action(deskApi.actions.playCard, { namespace: deskApi.namespace })
  playCard!: (cardName: string) => Promise<void>;

  onCardClicked(cardName: string) {
    console.log("onCardClicked", cardName);
    if (this.isMyTurn && this.allowedCards.includes(cardName)) {
      this.playCard(cardName)
        .then(() => {
          console.log(`card '${cardName}' played.`);
        })
        .catch(err => {
          console.error("play card failed: ", err);
        });
    }
  }
}
